var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 952,
    viewBox: "0 0 1440 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V705.776C1440 705.776 1359.5 778.977 1255 787.439C1150.5 795.902 1137.5 705.776 1058.75 705.776C980 705.776 964 787.439 867.5 787.439C771 787.439 763 726.14 668 726.14C573 726.14 547 787.439 443.5 787.439C340 787.439 364 783.262 224 726.14C84 669.018 0 705.776 0 705.776V0Z",
    fill: "url(#paint0_linear_755_147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212 15.5C337 219.5 501 206 548 206C595 206 789.994 197.332 929.5 94.5C1026.5 23 1062 -120 1223 122C1317.9 264.639 1509 65 1581 56.5",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1164 -25.8157C1198.38 -16.8944 1258.11 14.5179 1287.02 45.3597C1350.83 113.424 1317.32 131.497 1397.66 225.212C1461.93 300.184 1496.36 297.584 1516.77 305.162",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-37 469.5C173 469.5 239.5 505.5 257 795",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-23 619.5C80.3333 626.5 322.4 684.1 464 858.5",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.071 743.547C41.5105 720.845 7.20682 664.4 2 639.016V853H1440V639.016C1323.77 605.716 1438.06 790.455 1222.69 790.455C1162.51 790.455 1151.48 711.406 987.007 695.769C825.866 680.45 854.693 783.506 682.868 776.846C511.043 770.186 565.255 703.587 430.184 679.264C310.602 657.731 256.521 771.923 137.071 743.547Z",
    fill: "white",
    fillOpacity: 0.45,
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1264.82 762.716C1388.76 723.457 1433.25 625.844 1440 581.945V952L-425 952V581.945C-274.251 524.358 -422.487 843.838 -143.165 843.838C-65.1086 843.838 -50.8083 707.132 162.505 680.092C371.495 653.599 334.109 831.82 556.955 820.302C779.802 808.785 709.492 693.612 884.671 651.549C1039.76 614.309 1109.9 811.79 1264.82 762.716Z",
    fill: "#F6F4FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_147",
    x1: 1879.2,
    y1: 394,
    x2: -439.2,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.4627f5723a7a57e9d461226110f4c55a.svg";
export { ForwardRef as ReactComponent };